import React from 'react';
import { Box } from '@televet/kibble-ui/build/chakra';
import { Button } from '@televet/kibble-ui/build/components/Button';

interface AddPromptButtonProps {
  onClick: () => void;
  isDisabled: boolean;
}

export const AddPromptButton = ({ onClick, isDisabled }: AddPromptButtonProps): JSX.Element => {
  return (
    <Box
      w="100%"
      border="1px"
      borderColor="border.default"
      borderRadius="md"
      mt={6}
      p={1}
      className="Automations__AddPromptButton"
    >
      <Button size={'sm'} isDisabled={isDisabled} isFullWidth variant="ghostNeutral" iconName="plus" onClick={onClick}>
        Add Prompt
      </Button>
    </Box>
  );
};
